import { useMemo } from 'react';

import { BlankPage as BlankPageType } from 'types/page';
import { isPageFullyHidden } from 'utils/display-logic/pageVisibility';

import { useEvaluateDisplayCondition } from './useEvaluateDisplayCondition';

/**
 * Hook to determine if a page should be hidden because all its elements are hidden
 * due to conditional logic evaluation
 */
export function useIsPageFullyHidden(page: BlankPageType | null | undefined): boolean {
  const evaluateDisplayCondition = useEvaluateDisplayCondition();

  const isFullyHidden = useMemo(
    () => !page || isPageFullyHidden(page, evaluateDisplayCondition),
    [page, evaluateDisplayCondition],
  );

  return isFullyHidden;
}
